import React from 'react';
import { Box, Flex, HStack, IconButton, Text } from '@chakra-ui/react';
import { Handle, Position } from 'reactflow';
import { FiCheckCircle, FiTrash2 } from 'react-icons/fi';

const EndNode = ({ data }) => {
  return (
    <Box
      bg="white"
      borderWidth="2px"
      borderColor="gray.400"
      borderRadius="xl"
      boxShadow="lg"
      minW="200px"
    >
      <Handle type="target" position={Position.Left} style={{ background: 'black' }} />
      <Flex
        bg="gray.400"
        color="white"
        px={4}
        py={3}
        borderRadius="xl"
        align="center"
        justify="space-between"
        gap={2}
      >
        <HStack>
          <FiCheckCircle size={20} />
          <Text fontWeight="medium">End</Text>
        </HStack>
        <IconButton
          size="xs"
          variant="ghost"
          colorScheme="whiteAlpha"
          icon={<FiTrash2 />}
          onClick={(e) => {
            e.stopPropagation();
            data.onDelete?.(data.id);
          }}
        />
      </Flex>
    </Box>
  );
};

export default EndNode;
